module.exports = __webpack_public_path__ + "static/media/expGreen.b748ee88.svg";